module.exports = __webpack_public_path__ + "img/icon-googlemaps.4478dcc1.png";